// extracted by mini-css-extract-plugin
export default {"newBuildingPopover":"popover_newBuildingPopover__mVDa7","searchPopover":"popover_searchPopover__N-yPV"};